




export enum Dir {
    Up = 'up',
    Down = 'down'
}



export enum Size {
    XS =  0,
    SM =  576,
    MD =  768,
    LG =  992,
    XL =  1200,
    XXL = 1400
}
